"use client";

import styles from "./Colours.module.scss";
import { ColourList } from "./ColourList/ColourList";
import { getBaseUrlAndQuery } from "@/utils/url/getBaseUrlAndQuery";
import { ColourOption } from "@/components/Colours/types.ts";

type Props = {
  /**
   * An array of colour option objects.
   */
  colourOptions: ColourOption[];
  /**
   * A string which represents the product brand name.
   */
  brand?: string;
  /**
   * A boolean toggling history push with replace
   */
  replaceHistoryEntryOnVariantChange: boolean;
};

export const buildColourSwatchUrl = (
  colourSwatchUrl: string | null | undefined,
) => {
  const { baseUrl, query } = getBaseUrlAndQuery(colourSwatchUrl) || [];
  if (baseUrl) {
    const colourSwatchParams = new URLSearchParams(query);
    colourSwatchParams.append("wid", "24");
    colourSwatchParams.append("hei", "24");
    colourSwatchParams.append("sm", "c");
    return `${baseUrl}?${colourSwatchParams.toString()}`;
  }
  return;
};

export const ColoursUI = ({
  colourOptions,
  brand,
  replaceHistoryEntryOnVariantChange,
}: Props) => {
  return (
    <>
      <h2 className={styles.visuallyHidden}>Colours</h2>
      <ColourList
        colourOptions={colourOptions}
        brand={brand}
        replaceHistoryEntryOnVariantChange={replaceHistoryEntryOnVariantChange}
      />
    </>
  );
};
